import page from './page'

export default {
    install: function (Vue) {
        Vue.component('my-page', page)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js